import {Animated, ImageBackground} from "react-native"

const AnimatedImageBackground = Animated.createAnimatedComponent(ImageBackground)

export default AnimatedImageBackground
